<template>
	<ViewWorkbenchLegacy v-if="!showNewUi" />
	<ViewWorkbenchNext v-else />
</template>

<script lang="ts">
import ViewWorkbenchLegacy from '@/components/workbench/ViewWorkbenchLegacy.vue';
import ViewWorkbenchNext from '@/components/workbench/ViewWorkbenchNext.vue';
import { useFlag } from '@/composables/UseFeatureFlag';

// Route-level gate only (FACT-5963) — no business logic here. `v-if`/`v-else`,
// not `v-show`: the "off" side must never mount, so it never fires its own
// data fetches. Keeps the registered route/path unchanged (POINT links
// directly to /workbench), so this file owns the `route` property and
// nothing else. Remove this gate and ViewWorkbenchLegacy.vue once the new
// UI has been in prod a couple of weeks — see WORKBENCH_NEW_UI in
// EnvFeatureFlagService.ts.
export default {
	name: 'ViewWorkbench',
	route: {
		path: '/workbench',
		meta: {
			requiresAuth: true,
			title: 'Underwriter Workbench'
		}
	},
	components: {
		ViewWorkbenchLegacy,
		ViewWorkbenchNext,
	},
	setup() {
		// Static for the life of the session — flag is build-time env-var
		// backed (EnvFeatureFlagService), not a value that changes mid-session.
		const showNewUi = useFlag('WORKBENCH_NEW_UI');

		return { showNewUi };
	},
}
</script>
